module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"more":"Подробнее"},"en":{"more":"More details"}}')
  delete Component.options._Ctor
}
